﻿{
  "community": {
    "name": "Comunidad",
    "shortDescription": "Cuenta única con actividades gratuitas.",
    "features": [
      "Encuentre y comparta actividades",
      "Acceda a un administrador de actividades ilimitado en la nube.",
      "Acceda a las actividades prémium."
    ],
    "price": "Libre",
    "termName": "De por vida"
  },
  "personal": {
    "name": "Personal",
    "shortDescription": "Cuenta única con actividades personalizadas.",
    "features": [
      "Cree y edite las actividades en línea.",
      "Incluye una lista de reproducción personal.",
      "Acceda a las actividades desde cualquier lugar."
    ]
  },
  "professional": {
    "name": "Profesional",
    "shortDescription": "Cuenta única con varios estudiantes.",
    "features": [
      "Administre las tareas de los estudiantes.",
      "Supervise el progreso de los estudiantes.",
      "Colabore con los miembros del equipo."
    ]
  },
  "organization": {
    "name": "Organización",
    "shortDescription": "Varias cuentas con varios estudiantes.",
    "features": [
      "Incluye un administrador de instructores.",
      "Provee informes a nivel de la organización.",
      "Brinda configuraciones de privacidad empresarial."
    ],
    "price": "Contáctenos",
    "termName": "Plazos de 1 a 5 años."
  },
  "trialLicense": {
    "name": "Boardmaker 7",
    "shortDescription": "Vista previa del editor del escritorio.",
    "note": "¡Pruébelo <1>$t(common:action.free)</1> por 30 días!",
    "price": "Libre",
    "termName": "Prueba de 30 días.",
    "footerNote": "1 instalación"
  },
  "boardmakerLicense": {
    "name": "Boardmaker 7",
    "shortDescription": "Editor integral del escritorio.",
    "note": "",
    "termName": "Compra única",
    "footerNote": "2 instalaciones por usuario"
  },
  "licenseRequest": {
    "name": "Boardmaker 7",
    "shortDescription": "Varias licencias para organizaciones.",
    "note": "",
    "price": "Contáctenos",
    "termName": "Descuentos por volumen",
    "footerNote": "2 instalaciones por usuario"
  }
}
